import React from "react";

import type { IPopupHoverContainerProps } from "@similarweb/ui-components";
import { PopupHoverContainer } from "@similarweb/ui-components";

import type { VerifiedDataToggleInfoTooltipContentProps } from "./VerifiedDataToggleInfoTooltipContent";
import { VerifiedDataToggleInfoTooltipContent } from "./VerifiedDataToggleInfoTooltipContent";

type IVerifiedDataToggleInfoTooltip = Pick<
    IPopupHoverContainerProps["config"],
    "enabled" | "placement" | "cssClass" | "cssClassContent" | "allowHover"
> &
    VerifiedDataToggleInfoTooltipContentProps;

export class VerifiedDataToggleInfoTooltip extends React.Component<
    React.PropsWithChildren<IVerifiedDataToggleInfoTooltip>
> {
    static defaultProps = {
        enabled: true,
        placement: "bottom",
        cssClass: "verified-data-toggle-info-tooltip-element",
        cssClassContent: "verified-data-toggle-info-tooltip-element-content",
        allowHover: true,
    };

    constructor(props: IVerifiedDataToggleInfoTooltip) {
        super(props);
    }

    render() {
        return (
            <PopupHoverContainer
                content={() => (
                    <VerifiedDataToggleInfoTooltipContent onGAWizardModalOpen={this.props.onGAWizardModalOpen} />
                )}
                config={{
                    enabled: this.props.enabled,
                    placement: this.props.placement,
                    cssClass: this.props.cssClass,
                    cssClassContent: this.props.cssClassContent,
                    allowHover: this.props.allowHover,
                }}
            >
                {this.props.children}
            </PopupHoverContainer>
        );
    }
}
